import { getConfig, camelCaseObject } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { LOCKED, PARTIALLY_LOCKED, UNLOCKED } from '../constants';

async function fetchSequenceBlocks(id) {
  const LmsApiUrl = getConfig().LMS_BASE_URL;
  const sequenceUrl = `${LmsApiUrl}/api/courseware/sequence/${id}`;
  const gatedContent = {};

  try {
    let gatedContentCount = 0;
    const { data: { items } } = await getAuthenticatedHttpClient().get(sequenceUrl);
    camelCaseObject(items).forEach(item => {
      const { containsContentTypeGatedContent } = item;
      if (containsContentTypeGatedContent) {
        gatedContentCount += 1;
      }
    });

    if (gatedContentCount === 0) {
      gatedContent[id] = UNLOCKED;
    } else if (gatedContentCount === items.length) {
      gatedContent[id] = LOCKED;
    } else {
      gatedContent[id] = PARTIALLY_LOCKED;
    }
  } catch (error) {
    gatedContent[id] = UNLOCKED;
  }

  return gatedContent;
}

export default fetchSequenceBlocks;
